import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  LeftArrow, RightArrow, TickContainer, TickLine, TickText,
} from './styles';

// *******************************************************
// RAIL
// *******************************************************
const railOuterStyle = {
  position: 'absolute',
  width: '100%',
  height: 60,
  transform: 'translate(0%, -50%)',
  cursor: 'pointer',
  backgroundColor: '#262626',
  // border: "1px solid grey"
};

const railInnerStyle = {
  position: 'absolute',
  width: '100%',
  height: 60,
  transform: 'translate(0%, -50%)',
  pointerEvents: 'none',
  backgroundColor: '#262626',
};

export function SliderRail({ getRailProps }) {
  return (
    <>
      <div style={railOuterStyle} {...getRailProps()} />
      <div style={railInnerStyle} />
    </>
  );
}

SliderRail.propTypes = {
  getRailProps: PropTypes.func.isRequired,
};

const calcHandlePosition = (id, isLargeView) => {
  if (id.includes('0')) {
    return 'translate(0%, -50%)';
  }

  if (isLargeView) {
    return 'translate(-90%, -50%)';
  }

  return 'translate(-50%, -50%)';
};

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
export function Handle({
  domain: [min, max],
  handle: { id, value, percent },
  disabled,
  getHandleProps,
  isLargeView,
}) {
  return (
    <>
      <div
        style={{
          left: `${percent}%`,
          position: 'absolute',
          transform: 'translate(-50%, -50%)',
          WebkitTapHighlightColor: 'rgba(0,0,0,0)',
          zIndex: 5,
          width: 24,
          height: 42,
          cursor: 'pointer',
          backgroundColor: 'none',
        }}
        {...getHandleProps(id)}
      />
      <div
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        style={{
          left: `${percent}%`,
          position: 'absolute',
          transform: calcHandlePosition(id, isLargeView),
          zIndex: 2,
          width: 20,
          height: 50,
          backgroundColor: disabled ? '#666' : '#c50000',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {id.includes('0') ? <LeftArrow /> : <RightArrow />}
      </div>
    </>
  );
}

Handle.propTypes = {
  domain: PropTypes.array.isRequired,
  handle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getHandleProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isLargeView: PropTypes.bool,
};

Handle.defaultProps = {
  disabled: false,
  isLargeView: false,
};

// *******************************************************
// TRACK COMPONENT
// *******************************************************
export function Track({
  source, target, getTrackProps, disabled,
}) {
  return (
    <div
      style={{
        position: 'absolute',
        transform: 'translate(0%, -50%)',
        height: 50,
        zIndex: 1,
        backgroundColor: disabled ? '#999' : 'white',
        borderColor: '#c50000',
        borderWidth: 10,
        borderStyle: 'solid',
        borderRadius: 2,
        cursor: 'pointer',
        left: `${source.percent}%`,
        width: `${(target.percent - source.percent) - 2}%`,
      }}
      {...getTrackProps()}
    />
  );
}

Track.propTypes = {
  source: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  target: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getTrackProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Track.defaultProps = {
  disabled: false,
};

// *******************************************************
// TICK COMPONENT
// *******************************************************
export function Tick({ tick, count, format }) {
  return (
    <TickContainer>
      <TickLine
        percent={tick.percent}
        count={count}
      />
      <TickText
        percent={tick.percent}
        count={count}
      >
        {format(tick.value)}
      </TickText>
    </TickContainer>
  );
}

Tick.propTypes = {
  tick: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  count: PropTypes.number.isRequired,
  format: PropTypes.func.isRequired,
};

Tick.defaultProps = {
  format: (d) => d,
};
